
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_486_297)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#04080E"}},[_c('path',{attrs:{"d":"M1 3a1 1 0 011 1v5h5a1 1 0 010 2H1a1 1 0 01-1-1V4a1 1 0 011-1zM16 14a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 11-2 0v-5h-5a1 1 0 01-1-1z"}}),_c('path',{attrs:{"d":"M9.227 2.396a10 10 0 0112.206 6.27 1 1 0 11-1.886.668A8 8 0 006.325 6.369l-4.64 4.36A1 1 0 11.315 9.27l4.63-4.35a10 10 0 014.282-2.525zm14.502 10.92a1 1 0 01-.044 1.413l-4.63 4.35a10 10 0 01-16.488-3.745 1 1 0 111.886-.668 8 8 0 0013.2 2.987l.013-.013.01-.009 4.64-4.36a1 1 0 011.413.044z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_486_297"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    